import React from 'react'
import ReactSelect from 'react-select'

const CustomSelector = (props) => {
    // const { options, value, styles, form, field, onChange } = props
    // console.log("Props here ", field?.value);

    // function defaultValue(options, value) {
    //     let array = options ? options.find(item => item.value == field?.value) : ''
    //     console.log("Array  ", array, "  ", options, "    ", value);
    //     return options ? options.find(item => item.value == field?.value) : ''
    // }


    return (
        <div>
            {/* <ReactSelect isMulti options={options}
                value={defaultValue(options, field?.value)} customStyles={styles}
                onChange={(obj) => {
                    form.setFieldValue(field.name, obj.value)
                    onChange(obj)
                    console.log("e here:    ", value)
                }} /> */}
        </div>
    )
}

export default CustomSelector
